import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from '@reduxjs/toolkit';
import { fetchTrialWithUserEnrollmentAndSumbission } from '../redux/actions';
import Survey from '../components/survey/Survey';

import {
  submissionPayloadShape,
  surveyShape,
  trialShape,
} from '../types';
import withRouter from '../hoc/withRouter';

class ShowSubmissionView extends Component {
  componentDidMount() {
    const {
      user,
      router,
      fetchTrialWithUserEnrollmentAndSumbission:
      fetchTrialWithUserEnrollmentAndSubmissionAction,
    } = this.props;

    if (user.role !== 'admin') {
      const enrollmentId = router.params?.enrollmentId;
      fetchTrialWithUserEnrollmentAndSubmissionAction(enrollmentId);
    }
  }

  render() {
    let surveyPayload = null;
    let submissionPayload = null;
    const {
      user,
      trial,
      submissionPayload: propsSubmissionPayload,
      survey,
      router,
    } = this.props;
    if (user.role !== 'admin') {
      if (!trial || !trial.id || !propsSubmissionPayload) {
        return false;
      }
      surveyPayload = survey.payload;
      submissionPayload = propsSubmissionPayload;
    } else {
      // if admin then we dont open new tab currently so we load data from location.state.
      // (in the future we can replace passing data from location.state
      // and put in redux store when user select some trial)
      const state = router.location?.state;
      if (!state) {
        return false;
      }
      surveyPayload = state.survey.payload;
      submissionPayload = state.submission.payload;
    }

    return (
      <Survey
        surveyPayload={surveyPayload}
        submissionPayload={submissionPayload}
      />
    );
  }
}

ShowSubmissionView.defaultProps = {
  trial: undefined,
  survey: undefined,
  submissionPayload: undefined,
  user: {},
};

ShowSubmissionView.propTypes = {
  router: PropTypes.shape({
    params: PropTypes.object,
    location: PropTypes.shape({
      state: PropTypes.shape({
        submission: submissionPayloadShape,
        survey: surveyShape,
      }),
    }),
  }).isRequired,
  trial: trialShape,
  survey: surveyShape,
  submissionPayload: submissionPayloadShape,
  fetchTrialWithUserEnrollmentAndSumbission: PropTypes.func.isRequired,
  user: PropTypes.shape({
    id: PropTypes.string,
    ttl: PropTypes.number,
    created: PropTypes.string,
    userId: PropTypes.number,
    role: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.string),
    email: PropTypes.string,
  }),
};

const mapStateToProps = (state) => ({
  trial: state.trial.trial,
  survey: state.trial.trial ? state.trial.trial.survey : undefined,
  user: state.users.token,
  submissionPayload: state.trial.trial && state.trial.trial.enrollment
    && state.trial.trial.enrollment.submission.payload
    ? state.trial.trial.enrollment.submission.payload : undefined,
});

const mapDispatchToProps = (dispatch) => (bindActionCreators({
  fetchTrialWithUserEnrollmentAndSumbission,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShowSubmissionView));
